import { render } from "./NotFound.vue?vue&type=template&id=c44b5056"
const script = {}

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__